import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./index.scss";
import img from "../../../assets/images/bgfooter.png";
import { BtnNewsLetter } from "../../../assets/icons/BtnNewsLetter";
import logo from "../../../assets/images/logoF.png";
import { Link } from "react-router-dom";

const LandingSection = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError(""); // Clear error when user types
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Veuillez entrer votre adresse email");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch("https://api.almasecret.msit-demo.fr/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      const data = await response.json();

      if (response.ok) {
        setShowSuccess(true);
        setEmail("");
      } else {
        setError(data.message || "Erreur lors de l'inscription");
      }
    } catch (error) {
      setError("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="landing-section">
      {/* Haut : image produit + bloc newsletter */}
      <div className="bg-image w-100">
        <img
          src={img}
          alt="Produit Alma Secret"
          className="product-img-1 w-100"
        />
      </div>
      {/* Footer */}

      <Row className="align-items-center top-section mx-0">
        {/* Footer */}
        <Col md={6} className="order-2 order-md-1">
          <Row className="footer">
            <Col md={4} className="footer-col">
              <h6>EXPLORE</h6>
              <ul>
                <li>
                  <Link to="/apropos">À PROPOS</Link>
                </li>
                <li>
                  <Link to="/">ACCUEIL</Link>
                </li>
                <li>
                  <Link to="/all-products">NOS PRODUITS</Link>
                </li>
                <li>
                  <Link to="/login-page">SIGN UP / LOGIN</Link>
                </li>
              </ul>
            </Col>

            <Col md={4} className="footer-col">
              <h6>FOLLOW US</h6>
              <ul>
                <li>INSTAGRAM</li>
                <li>FACEBOOK</li>
              </ul>
            </Col>

            <Col md={4} className="footer-col">
              <h6>CONTACT US</h6>
              <ul>
                <li>tk@brandname.com</li>
                <li>1111-2222-3333</li>
              </ul>
            </Col>

            <Col md={12} className="footer-bottom">
              <img
                src={logo}
                alt="Produit Alma Secret"
                className="footer-img"
              />
              <p>
                Clean, Conscious, Clinical Skincare! Honest products that truly
                work
              </p>
              <p className="credits">© 2025 ALMA SECRET, All Rights Reserved</p>
            </Col>
          </Row>
        </Col>

        {/* Newsletter */}
        <Col md={6} className="newsletter-col order-1 order-md-2">
          <div className="newsletter-box">
            <h2 className="newsletter-title">
              DÉCOUVREZ <br /> -EN PLUS
            </h2>
            <p className="newsletter-text">
              Get the latest news about skincare tips and new products.
            </p>
            <Form
              onSubmit={handleNewsletterSubmit}
              className="newsletter-form w-100">
              <Form.Group controlId="formEmail" className="w-100">
                <Form.Control
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="ENTER YOUR EMAIL."
                  className="newsletter-input"
                  required
                />
              </Form.Group>
              {error && <div className="newsletter-error">{error}</div>}
              <Button
                type="submit"
                className={`btn-subscribe ${isLoading ? "loading" : ""}`}
                disabled={isLoading}>
                <div className="newsletter-btn">
                  <BtnNewsLetter />
                </div>
                {isLoading ? "..." : "Subscribe"}
              </Button>
            </Form>
            <hr className="line-color" />
            <p className="newsletter-note">
              No Spam, only quality articles to help you. You can unsubscribe at
              any time.
            </p>
          </div>
          <div className="text-center footer-links d-none d-md-block ">
            <a href="#" className="me-3">
              Disclaimer
            </a>
            <a href="#" className="me-3">
              Credits
            </a>
            <span>Website By: MSITCONSEIL</span>
          </div>
        </Col>
      </Row>

      {/* Success Popup */}
      {showSuccess && (
        <div className="newsletter-success-popup">
          <div className="newsletter-success-content">
            <div className="newsletter-success-icon">✓</div>
            <h2 className="newsletter-success-title">Inscription réussie!</h2>
            <p className="newsletter-success-message">
              Vous êtes maintenant abonné à notre newsletter. Merci de votre
              confiance!
            </p>
            <button
              className="newsletter-success-button"
              onClick={() => setShowSuccess(false)}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default LandingSection;
